import React, { useEffect, useState } from "react";
import { Section, ToolbarButton } from "./UI";
import { LeadCard } from "./LeadCard";

/**
 * Компонент для просмотра одного лида (deep linking)
 */
export function LeadDetail({ leadId, loadSingleLead, startEdit, handleDelete, setView, role }) {
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLead = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log('[LeadDetail] Loading lead:', leadId);
        console.log('[LeadDetail] Lead ID type:', typeof leadId);
        console.log('[LeadDetail] Lead ID length:', leadId?.length);
        
        const loadedLead = await loadSingleLead(leadId);
        setLead(loadedLead);
        
        console.log('[LeadDetail] Lead loaded successfully:', loadedLead);
      } catch (err) {
        console.error('[LeadDetail] Failed to load lead:', err);
        console.error('[LeadDetail] Error details:', {
          message: err.message,
          stack: err.stack,
          leadId: leadId
        });
        setError(err.message || 'Не удалось загрузить лида');
      } finally {
        setLoading(false);
      }
    };

    if (leadId) {
      console.log('[LeadDetail] Starting fetch for leadId:', leadId);
      fetchLead();
    } else {
      console.error('[LeadDetail] No leadId provided!');
    }
  }, [leadId, loadSingleLead]);

  if (loading) {
    return (
      <Section title="Загрузка лида...">
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">Загрузка...</p>
          </div>
        </div>
      </Section>
    );
  }

  if (error) {
    return (
      <Section
        title="Ошибка"
        right={<ToolbarButton onClick={() => setView("home")}>На главную</ToolbarButton>}
      >
        <div className="text-center py-12">
          <div className="text-6xl mb-4">⚠️</div>
          <p className="text-red-600 dark:text-red-400 mb-4">{error}</p>
          <button
            onClick={() => setView("home")}
            className="px-4 py-2 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition-colors"
          >
            Вернуться на главную
          </button>
        </div>
      </Section>
    );
  }

  if (!lead) {
    return (
      <Section
        title="Лид не найден"
        right={<ToolbarButton onClick={() => setView("home")}>На главную</ToolbarButton>}
      >
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🔍</div>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            Лид не найден или удален
          </p>
          <button
            onClick={() => setView("home")}
            className="px-4 py-2 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition-colors"
          >
            Вернуться на главную
          </button>
        </div>
      </Section>
    );
  }

  return (
    <Section
      title="Карточка лида"
      right={<ToolbarButton onClick={() => setView("home")}>На главную</ToolbarButton>}
    >
      <LeadCard
        lead={lead}
        onEdit={startEdit}
        onDelete={handleDelete}
        readOnly={false}
        showManager={true}
      />
      
      <div className="mt-4 flex gap-3">
        <button
          onClick={() => setView("list")}
          className="flex-1 px-4 py-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        >
          Все мои лиды
        </button>
        <button
          onClick={() => setView("home")}
          className="flex-1 px-4 py-2 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition-colors"
        >
          На главную
        </button>
      </div>
    </Section>
  );
}
